// middleware/03.admin-2fa.global.ts
//
// Client-side mirror of server/middleware/admin-2fa.ts.
// Redirects superadmins to the 2FA gate when accessing /admin/**
// and the admin_2fa_verified cookie is not present.
//
// R7-ADM-2FA-COOKIE-01: admin_2fa_verified is HttpOnly (correctly — it's the
// real gate, read by server/middleware/admin-2fa.ts / the AWS BE equivalent,
// and must stay unreadable from JS). useCookie() here can NEVER see it, so
// this middleware bounced a just-verified superadmin straight back to the
// 2FA page in an infinite loop. admin_2fa_ok is a NON-HttpOnly mirror set by
// the same verify/disable calls (supabase/functions/admin-2fa,
// api/modules/auth-admin/sessions/admin-2fa.ts) — carries only a boolean, no
// secret — so this client-only UX check has something it can actually read.
// The server-side gate is untouched: it never reads this cookie.

export default defineNuxtRouteMiddleware((to) => {
  const cfg = useRuntimeConfig()
  if (cfg.public.admin2faEnabled !== true) return

  if (!to.path.startsWith('/admin')) return
  if (to.path.startsWith('/admin/security/2fa')) return

  const authStore = useAuthStore()
  if (!authStore.isSuperadmin) return

  const cookie = useCookie<string | null>('admin_2fa_ok')
  if (cookie.value === '1') return

  return navigateTo('/admin/security/2fa')
})
